export class Success {
  public message: string;
  public routeUrl: string;

  constructor (
    message = '',
    routeUrl = ''
  ) {}
}


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/success.ts